// Stable, anonymous, per-install identifier.
const INSTALL_ID_KEY = 'baobab_install_id';

// `crypto.randomUUID` needs Safari 15.4; our build targets safari15/ios15, so an older WebKit would
// throw.
const generateUuidV4 = (): string => {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

let cached: string | null = null;

export const peekInstallId = (): string | null => {
  try {
    return localStorage.getItem(INSTALL_ID_KEY);
  } catch {
    return null;
  }
};

export const getOrCreateInstallId = (): string => {
  if (cached) return cached;
  try {
    const stored = localStorage.getItem(INSTALL_ID_KEY);
    if (stored) {
      cached = stored;
      return stored;
    }
    const generated = generateUuidV4();
    localStorage.setItem(INSTALL_ID_KEY, generated);
    cached = generated;
    return generated;
  } catch {
    // Storage can throw (private mode, quota, disabled cookies). Never let telemetry identity break
    // boot.
    return 'unknown';
  }
};
